import objToArr from "@helpers/objToArr";

const TRAINING_MANAGER = "Training Manager";
const COMPANY_MANAGER = "Company Manager";

function toggleAcl(acl) {
  const aclName = acl.name;
  const newValue = !this.model.acls[acl.id].active;
  this.model.acls[acl.id].active = newValue;

  const nameToUntoggle = {
    [TRAINING_MANAGER]: COMPANY_MANAGER,
    [COMPANY_MANAGER]: TRAINING_MANAGER
  }[aclName];

  const aclToUntoggle = objToArr(this.model.acls).find(
    acl => acl.name === nameToUntoggle
  );

  if (aclToUntoggle) {
    this.model.acls[aclToUntoggle.id].active = false;
  }

  if (aclName === "Trainee") {
    this.model.isTrainee = newValue;
  }
}

export default toggleAcl;
